import $ from 'jquery';
import urlparams from '../utility/urlparams';

const list = $('[data-listitemlimit]');
const listitems = list.children();
const listitemsToggleButton = $('[data-listitemlimittoggle]');
let limit = 9;
let limitStatus = true;

const itemLimitClass = 'over-limit';
const expandedHash = 'showall';

function clearLimitClass(){
    const items = list.find('.' + itemLimitClass);
    items.removeClass(itemLimitClass);

    // hide Button for now
    $(window).trigger('lazyload');
    listitemsToggleButton.hide();

    // if hidden element has styling for elementQuery.js their wil refresh if elementQuery exists
    if (typeof(window.elementQuery) === 'function'){
        window.elementQuery();
    }
}

function updateList(){
    if (limitStatus){
        listitems.each(function(i, el){
            if (i >= limit){
                $(el).addClass(itemLimitClass);
            } else {
                $(el).removeClass(itemLimitClass);
            }
        });
    } else {
        clearLimitClass();
    }
}

function toggleLimit(){
    limitStatus = !limitStatus;
    updateList();
}

function init() {
    if (list.length < 1 || listitems.length < 1) return;

    if (+list.data('listitemlimit') === 0) {
        setTimeout(clearLimitClass, 300);
        return;
    }
    limit = (list.data('listitemlimit')) ? list.data('listitemlimit') : limit;


    // add button functionality
    $(listitemsToggleButton.find('button')).on('click', function buttonHandler(){
        urlparams.setHash(expandedHash);
        toggleLimit();
    });

    // showall if hash is set
    if (urlparams.getHash() === expandedHash){
        clearLimitClass();
        return;
    }

    // show all if there is less than limit
    if (limit >= listitems.length || limit === 0) {
        clearLimitClass();
    } else {
        updateList();
    }
}

function applylimitClass(){
    limitStatus = true;
    updateList();
    listitemsToggleButton.show();
}

function getLimitClass(){
    return itemLimitClass;
}

export default {
    init: init,
    applylimitClass: applylimitClass,
    clearLimitClass: clearLimitClass,
    getLimitClass: getLimitClass
};
